import { render, staticRenderFns } from "./SiteCreateModal.vue?vue&type=template&id=63c1868a&scoped=true"
import script from "./SiteCreateModal.vue?vue&type=script&lang=js"
export * from "./SiteCreateModal.vue?vue&type=script&lang=js"
import style0 from "./SiteCreateModal.vue?vue&type=style&index=0&id=63c1868a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c1868a",
  null
  
)

export default component.exports